import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

import { useGetCatagoryQuery } from "../../redux/slices/catagoryApiSlice";

import {
  useGetsTodosQuery,
  useAddsTodoMutation,
  useDeleteeTodoMutation,
} from "../../redux/slices/todoApiSlice";

import { setCatagory } from "../../redux/slices/catagorySlice";

import {
  Search,
  Filter,
  ArrowRight,
  AlertCircle,
  CheckCircle2,
  RefreshCw,
  Loader2,
  PackageOpen,
  SlidersHorizontal,
  X,
  Heart,
} from "lucide-react";

const Paginationdiz = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [priceRange, setPriceRange] = useState("all");
  const [inStock, setInStock] = useState("all");

  const scrollRef = useRef(null);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [isProductsLoading, setIsProductsLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [productsError, setProductsError] = useState("");
  const [categoryError, setCategoryError] = useState("");

  const [addingFavoriteId, setAddingFavoriteId] = useState(null);

  const categories = [
    "Elektronika",
    "Telefon",
    "Kompüter",
    "Məişət texnikası",
    "Mebel",
    "Avtomobil",
    "Geyim",
    "Ayaqqabı",
    "Uşaq məhsulları",
    "İdman",
    "Hobbi",
    "Kitab",
    "Digər",
  ];

  // =========================================================
  // CATEGORY QUERY
  // =========================================================

  const {
    data: categoryData,
    isLoading: isCategoryLoading,
    isError: isCategoryError,
    error: categoryQueryError,
    refetch: refetchCategories,
  } = useGetCatagoryQuery();

  // =========================================================
  // FAVORITE QUERY
  // =========================================================

  const { data: favoriteData } = useGetsTodosQuery();

  // =========================================================
  // FAVORITE MUTATIONS
  // =========================================================

  const [addFavorite] = useAddsTodoMutation();

  const [deleteeTodo] = useDeleteeTodoMutation();

  // =========================================================
  // ERROR MESSAGE
  // =========================================================

  const getErrorMessage = (error) => {
    if (!error) {
      return "Naməlum xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
    }

    const serverMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.data?.message ||
      error?.data?.message ||
      error?.data?.error;

    if (serverMessage) {
      return String(serverMessage);
    }

    const status = error?.response?.status || error?.status;

    if (status === 400) {
      return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa, seçimlərinizi yoxlayın.";
    }

    if (status === 401) {
      return "Sessiyanız başa çatıb. Zəhmət olmasa, hesabınıza yenidən daxil olun.";
    }

    if (status === 403) {
      return "Bu məlumatlara baxmaq üçün icazəniz yoxdur.";
    }

    if (status === 404) {
      return "Tələb olunan məlumat tapılmadı.";
    }

    if (status === 429) {
      return "Çox sayda sorğu göndərildi. Zəhmət olmasa, bir qədər gözləyib yenidən cəhd edin.";
    }

    if (status >= 500) {
      return "Serverdə texniki problem baş verdi. Zəhmət olmasa, bir qədər sonra yenidən cəhd edin.";
    }

    if (
      error?.code === "ERR_NETWORK" ||
      error?.message?.toLowerCase?.().includes("network")
    ) {
      return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın.";
    }

    if (error?.message) {
      return String(error.message);
    }

    return "Məlumatların yüklənməsi zamanı gözlənilməz xəta baş verdi.";
  };

  // =========================================================
  // CATEGORY DATA
  // =========================================================

  useEffect(() => {
    if (categoryData?.allCatagory) {
      dispatch(setCatagory(categoryData.allCatagory));
      setCategoryError("");
    }
  }, [categoryData, dispatch]);

  // =========================================================
  // CATEGORY ERROR
  // =========================================================

  useEffect(() => {
    if (isCategoryError) {
      const message = getErrorMessage(categoryQueryError);

      setCategoryError(message);

      toast.error(`Kateqoriyalar yüklənmədi: ${message}`);
    }
  }, [isCategoryError, categoryQueryError]);

  // =========================================================
  // FETCH PRODUCTS
  // =========================================================

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (page === 1) {
        setIsProductsLoading(true);
      } else {
        setIsLoadingMore(true);
      }

      setProductsError("");

      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/pagination/getpagenations?page=${page}`;

        const response = await axios.get(url);

        if (!isMounted) return;

        const newData = Array.isArray(
          response?.data?.allPagination
        )
          ? response.data.allPagination
          : [];

        setProducts((prevData) => {
          if (page === 1) {
            return newData;
          }

          const existingIds = new Set(
            prevData.map((item) => item?._id).filter(Boolean)
          );

          const uniqueNewData = newData.filter(
            (item) =>
              item?._id &&
              !existingIds.has(item._id)
          );

          return [...prevData, ...uniqueNewData];
        });

        const totalPages = Number(
          response?.data?.totalPages || 1
        );

        setHasMore(page < totalPages);
      } catch (error) {
        if (!isMounted) return;

        const message = getErrorMessage(error);

        setProductsError(message);

        if (page > 1) {
          toast.error(
            `Yeni məhsullar yüklənmədi: ${message}`
          );
        }
      } finally {
        if (!isMounted) return;

        setIsProductsLoading(false);
        setIsLoadingMore(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [page]);

  // =========================================================
  // GET PRODUCT ID FROM FAVORITE ITEM
  // =========================================================

  const getItemProductId = (item) => {
    return (
      item?.productId?._id ||
      item?.productId ||
      item?.product?._id ||
      item?.qolbaq?._id ||
      item?.qolbaqId?._id ||
      item?.qolbaqId ||
      item?._id
    );
  };

  // =========================================================
  // GET FAVORITE ITEMS
  // =========================================================

  const getFavoriteItems = () => {
    if (Array.isArray(favoriteData)) {
      return favoriteData;
    }

    if (Array.isArray(favoriteData?.favorie)) {
      return favoriteData.favorie;
    }

    if (Array.isArray(favoriteData?.allFavorie)) {
      return favoriteData.allFavorie;
    }

    if (Array.isArray(favoriteData?.favorites)) {
      return favoriteData.favorites;
    }

    if (Array.isArray(favoriteData?.todos)) {
      return favoriteData.todos;
    }

    if (Array.isArray(favoriteData?.allTodos)) {
      return favoriteData.allTodos;
    }

    if (Array.isArray(favoriteData?.data)) {
      return favoriteData.data;
    }

    return [];
  };

  // =========================================================
  // CHECK FAVORITE
  // =========================================================

  const isProductInFavorite = (productId) => {
    const favoriteItems = getFavoriteItems();

    return favoriteItems.some((item) => {
      const itemProductId = getItemProductId(item);

      return (
        itemProductId &&
        String(itemProductId) === String(productId)
      );
    });
  };

  // =========================================================
  // ADD / DELETE FAVORITE
  // =========================================================

  const handleAddToFavorite = async (product) => {
    const productId = product?._id;
    const productTitle = product?.title || "Məhsul";

    if (!productId) {
      toast.error("Məhsulun ID-si tapılmadı.");
      return;
    }

    if (addingFavoriteId === productId) {
      return;
    }

    const isFavorite = isProductInFavorite(productId);

    setAddingFavoriteId(productId);

    try {
      // =====================================================
      // ALREADY FAVORITE -> DELETE
      // =====================================================

      if (isFavorite) {
        const favoriteItems = getFavoriteItems();

        const favoriteItem = favoriteItems.find((item) => {
          const itemProductId =
            getItemProductId(item);

          return (
            itemProductId &&
            String(itemProductId) ===
              String(productId)
          );
        });

        if (!favoriteItem?._id) {
          toast.error(
            "Sevimli məhsulun məlumatı tapılmadı. Məhsul silinə bilmədi."
          );

          return;
        }

        await deleteeTodo(
          favoriteItem._id
        ).unwrap();

        // ===================================================
        // REDUX DELETE
        // ===================================================

        dispatch({
          type: "favorie/delete",
          payload: favoriteItem._id,
        });

        // ===================================================
        // TOAST
        // ===================================================

        toast.success(
          `"${productTitle}" məhsulu sevimlilər siyahısından silindi.`
        );

        return;
      }

      // =====================================================
      // NOT FAVORITE -> ADD
      // =====================================================

      const newFavorite = await addFavorite({
        productId,
      }).unwrap();

      // =====================================================
      // REDUX ADD
      // =====================================================

      dispatch({
        type: "favorie/add",
        payload: newFavorite,
      });

      // =====================================================
      // TOAST
      // =====================================================

      toast.success(
        `"${productTitle}" məhsulu sevimlilərinizə əlavə olundu.`
      );
    } catch (error) {
      console.error(
        "Sevimli məhsul əməliyyatında xəta:",
        error
      );

      const status =
        error?.status ||
        error?.response?.status;

      const raw = String(
        error?.data?.message ||
          error?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          ""
      ).toLowerCase();

      // =====================================================
      // DUPLICATE ADD
      // =====================================================
      // Artıq varsa "artıq sevimlilərinizdədir"
      // toast göstərmirik.
      // Sadəcə əməliyyatı səssiz saxlayırıq.

      if (
        !isFavorite &&
        (
          status === 409 ||
          raw.includes("artıq") ||
          raw.includes("artiq") ||
          raw.includes("already") ||
          raw.includes("mövcud") ||
          raw.includes("movcud")
        )
      ) {
        return;
      }

      // =====================================================
      // DELETE ERROR
      // =====================================================

      if (isFavorite) {
        toast.error(
          `"${productTitle}" məhsulu sevimlilərdən silmək mümkün olmadı.`
        );

        return;
      }

      // =====================================================
      // ADD ERROR
      // =====================================================

      toast.error(
        `"${productTitle}" məhsulunu sevimlilərə əlavə etmək mümkün olmadı.`
      );
    } finally {
      setAddingFavoriteId(null);
    }
  };

  // =========================================================
  // LOAD MORE
  // =========================================================

  const loadMore = () => {
    if (
      hasMore &&
      !isLoadingMore &&
      !isProductsLoading
    ) {
      setPage((prev) => prev + 1);
    }
  };

  // =========================================================
  // RETRY PRODUCTS
  // =========================================================

  const handleRetryProducts = () => {
    setProductsError("");

    if (page === 1) {
      setProducts([]);
      setIsProductsLoading(true);
      setPage(1);
    } else {
      setPage(1);
    }
  };

  // =========================================================
  // RETRY CATEGORIES
  // =========================================================

  const handleRetryCategories = async () => {
    setCategoryError("");

    try {
      const result = await refetchCategories();

      if (result?.error) {
        toast.error(
          `Kateqoriyalar yenilənmədi: ${getErrorMessage(
            result.error
          )}`
        );
      } else {
        toast.success(
          "Kateqoriyalar uğurla yeniləndi."
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);

      setCategoryError(message);

      toast.error(
        `Kateqoriyalar yenilənmədi: ${message}`
      );
    }
  };

  // =========================================================
  // RESET FILTERS
  // =========================================================

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("all");
    setPriceRange("all");
    setInStock("all");
  };

  // =========================================================
  // FILTER
  // =========================================================

  const filteredProducts = products.filter(
    (product) => {
      const matchesSearch = product.title
        ?.toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        );

      const matchesCategory =
        selectedCategory === "all" ||
        product.category === selectedCategory;

      const matchesPrice =
        priceRange === "all" ||
        (priceRange === "low" &&
          product.price <= 50) ||
        (priceRange === "mid" &&
          product.price > 50 &&
          product.price <= 150) ||
        (priceRange === "high" &&
          product.price > 150);

      const matchesStock =
        inStock === "all" ||
        (inStock === "inStock" &&
          product.stock > 0) ||
        (inStock === "outOfStock" &&
          product.stock === 0);

      return (
        matchesSearch &&
        matchesCategory &&
        matchesPrice &&
        matchesStock
      );
    }
  );

  // =========================================================
  // SCROLL
  // =========================================================

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= 400;
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 400;
    }
  };

  // =========================================================
  // ACTIVE FILTER COUNT
  // =========================================================

  const activeFilterCount = [
    searchTerm.trim() !== "",
    selectedCategory !== "all",
    priceRange !== "all",
    inStock !== "all",
  ].filter(Boolean).length;

  // =========================================================
  // PRODUCT IMAGE
  // =========================================================

  const getProductImage = (product) => {
    if (
      Array.isArray(product?.photo) &&
      product.photo.length > 0
    ) {
      return product.photo[0];
    }

    if (
      typeof product?.photo === "string" &&
      product.photo.trim()
    ) {
      return product.photo;
    }

    return null;
  };

  // =========================================================
  // FORMAT PRICE
  // =========================================================

  const formatPrice = (price) => {
    if (
      price === null ||
      price === undefined ||
      price === ""
    ) {
      return "0";
    }

    const numericPrice = Number(price);

    if (Number.isNaN(numericPrice)) {
      return String(price);
    }

    return numericPrice.toLocaleString("az-AZ");
  };

  // =========================================================
  // INITIAL LOADING
  // =========================================================

  if (
    isProductsLoading &&
    products.length === 0
  ) {
    return (
      <div className="min-h-screen bg-slate-50 px-4 py-8 dark:bg-slate-950 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">

          <div className="mb-8 overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">

            <div className="h-1 bg-gradient-to-r from-indigo-500 via-violet-500 to-blue-500" />

            <div className="p-6 sm:p-8">

              <div className="flex items-center gap-4">

                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 dark:bg-indigo-500/10">
                  <Loader2 className="h-7 w-7 animate-spin text-indigo-500" />
                </div>

                <div>

                  <h2 className="text-xl font-bold text-slate-900 dark:text-white">
                    Məhsullar yüklənir...
                  </h2>

                  <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                    Məhsullar hazırlanır. Zəhmət olmasa, gözləyin.
                  </p>

                </div>

              </div>

            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

            {Array.from({ length: 8 }).map(
              (_, index) => (
                <div
                  key={index}
                  className="animate-pulse rounded-[28px] border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900"
                >
                  <div className="h-52 rounded-2xl bg-slate-200 dark:bg-slate-800" />

                  <div className="mt-5 h-5 w-3/4 rounded bg-slate-200 dark:bg-slate-800" />

                  <div className="mt-3 h-4 w-1/2 rounded bg-slate-200 dark:bg-slate-800" />

                  <div className="mt-5 h-12 rounded-2xl bg-slate-200 dark:bg-slate-800" />
                </div>
              )
            )}

          </div>

        </div>
      </div>
    );
  }

  // =========================================================
  // PRODUCT ERROR
  // =========================================================

  if (
    productsError &&
    products.length === 0
  ) {
    return (
      <div className="min-h-screen bg-slate-50 px-4 py-10 dark:bg-slate-950 sm:px-6">

        <div className="mx-auto flex min-h-[70vh] max-w-xl items-center justify-center">

          <div className="w-full overflow-hidden rounded-[30px] border border-red-200 bg-white shadow-xl shadow-red-100/50 dark:border-red-500/20 dark:bg-slate-900 dark:shadow-none">

            <div className="h-1 bg-gradient-to-r from-red-500 to-orange-500" />

            <div className="p-7 text-center sm:p-10">

              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 dark:bg-red-500/10">
                <AlertCircle className="h-8 w-8 text-red-500" />
              </div>

              <h2 className="mt-5 text-2xl font-bold text-slate-900 dark:text-white">
                Məhsullar yüklənmədi
              </h2>

              <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
                Məhsulların yüklənməsi zamanı problem yarandı.
              </p>

              <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 p-4 text-left dark:border-red-500/20 dark:bg-red-500/5">

                <p className="text-xs font-bold uppercase tracking-wide text-red-600 dark:text-red-400">
                  Xətanın səbəbi
                </p>

                <p className="mt-2 break-words text-sm leading-6 text-red-700 dark:text-red-300">
                  {productsError}
                </p>

              </div>

              <button
                type="button"
                onClick={handleRetryProducts}
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-indigo-500/20 transition hover:-translate-y-0.5 hover:from-indigo-500 hover:to-violet-500"
              >
                <RefreshCw className="h-4 w-4" />

                Yenidən cəhd edin
              </button>

            </div>
          </div>

        </div>
      </div>
    );
  }

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-white">

      {/* =========================================================
          PAGE HEADER
      ========================================================== */}

      <div className="border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">

        <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">

          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">

            <div className="flex items-center gap-4">

              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 text-white shadow-lg shadow-indigo-500/20">
                <PackageOpen className="h-7 w-7" />
              </div>

              <div>

                <h1 className="text-2xl font-black tracking-tight sm:text-3xl">
                  Elanlar
                </h1>

                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Sizə uyğun elanları kəşf edin
                </p>

              </div>

            </div>

            <div className="flex items-center gap-3">

              <div className="flex items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-800 dark:bg-slate-900">

                <PackageOpen className="h-4 w-4 text-indigo-500" />

                <span className="text-sm font-bold">
                  {filteredProducts.length}
                </span>

                <span className="text-sm text-slate-500 dark:text-slate-400">
                  elan
                </span>

              </div>

              {activeFilterCount > 0 && (
                <button
                  type="button"
                  onClick={resetFilters}
                  className="flex items-center gap-2 rounded-2xl bg-red-50 px-4 py-3 text-sm font-bold text-red-500 transition hover:bg-red-100 dark:bg-red-500/10 dark:hover:bg-red-500/20"
                >
                  <X className="h-4 w-4" />

                  Sıfırla
                </button>
              )}

            </div>

          </div>

        </div>

      </div>

      {/* =========================================================
          CATEGORY ERROR
      ========================================================== */}

      {categoryError && (
        <div className="mx-auto max-w-[1600px] px-4 pt-4 sm:px-6 lg:px-8">

          <div className="flex items-center justify-between rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-500/20 dark:bg-amber-500/10">

            <div className="flex items-center gap-2">

              <AlertCircle className="h-4 w-4 text-amber-500" />

              <span className="text-sm font-semibold text-amber-700 dark:text-amber-300">
                Kateqoriyalar yüklənmədi
              </span>

            </div>

            <button
              type="button"
              onClick={handleRetryCategories}
              className="rounded-xl bg-amber-500 px-4 py-2 text-xs font-bold text-white transition hover:bg-amber-600"
            >
              Yenilə
            </button>

          </div>

        </div>
      )}

      {/* =========================================================
          FILTERS
      ========================================================== */}

      <div className="mx-auto max-w-[1600px] px-4 pt-5 sm:px-6 lg:px-8">

        <div className="overflow-hidden rounded-[26px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">

          <div className="border-b border-slate-100 px-5 py-4 dark:border-slate-800 sm:px-6">

            <div className="flex items-center justify-between gap-4">

              <div className="flex items-center gap-3">

                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 dark:bg-indigo-500/10">
                  <SlidersHorizontal className="h-5 w-5 text-indigo-500" />
                </div>

                <div>

                  <h2 className="text-sm font-extrabold">
                    Məhsul axtarışı
                  </h2>

                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    Məhsulları filtrləyin
                  </p>

                </div>

              </div>

              {activeFilterCount > 0 && (
                <div className="hidden rounded-xl bg-indigo-50 px-3 py-2 text-xs font-bold text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400 sm:block">
                  {activeFilterCount} aktiv filtr
                </div>
              )}

            </div>

          </div>

          <div className="grid gap-3 p-4 sm:p-5 md:grid-cols-2 xl:grid-cols-4">

            {/* SEARCH */}

            <div className="relative">

              <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />

              <input
                type="text"
                placeholder="Məhsul axtarın..."
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
                className="
                  h-12
                  w-full
                  rounded-2xl
                  border
                  border-slate-200
                  bg-slate-50
                  pl-11
                  pr-4
                  text-sm
                  font-medium
                  outline-none
                  transition
                  placeholder:text-slate-400
                  focus:border-indigo-500
                  focus:bg-white
                  focus:ring-4
                  focus:ring-indigo-500/10
                  dark:border-slate-700
                  dark:bg-slate-950
                  dark:text-white
                  dark:focus:bg-slate-950
                "
              />

            </div>

            {/* CATEGORY */}

            <div className="relative">

              <select
                value={selectedCategory}
                onChange={(e) =>
                  setSelectedCategory(e.target.value)
                }
                disabled={isCategoryLoading}
                className="
                  h-12
                  w-full
                  appearance-none
                  rounded-2xl
                  border
                  border-slate-200
                  bg-slate-50
                  px-4
                  pr-10
                  text-sm
                  font-semibold
                  outline-none
                  transition
                  focus:border-indigo-500
                  focus:ring-4
                  focus:ring-indigo-500/10
                  disabled:cursor-not-allowed
                  disabled:opacity-60
                  dark:border-slate-700
                  dark:bg-slate-950
                  dark:text-white
                "
              >

                <option value="all">
                  {isCategoryLoading
                    ? "Kateqoriyalar yüklənir..."
                    : "Bütün kateqoriyalar"}
                </option>

                {categories.map((category) => (
                  <option
                    key={category}
                    value={category}
                  >
                    {category}
                  </option>
                ))}

              </select>

              <Filter className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />

            </div>

            {/* PRICE */}

            <select
              value={priceRange}
              onChange={(e) =>
                setPriceRange(e.target.value)
              }
              className="
                h-12
                rounded-2xl
                border
                border-slate-200
                bg-slate-50
                px-4
                text-sm
                font-semibold
                outline-none
                transition
                focus:border-indigo-500
                focus:ring-4
                focus:ring-indigo-500/10
                dark:border-slate-700
                dark:bg-slate-950
                dark:text-white
              "
            >

              <option value="all">
                Bütün qiymətlər
              </option>

              <option value="low">
                0 – 50 ₼
              </option>

              <option value="mid">
                51 – 150 ₼
              </option>

              <option value="high">
                151 ₼ və daha çox
              </option>

            </select>

            {/* STOCK */}

            <select
              value={inStock}
              onChange={(e) =>
                setInStock(e.target.value)
              }
              className="
                h-12
                rounded-2xl
                border
                border-slate-200
                bg-slate-50
                px-4
                text-sm
                font-semibold
                outline-none
                transition
                focus:border-indigo-500
                focus:ring-4
                focus:ring-indigo-500/10
                dark:border-slate-700
                dark:bg-slate-950
                dark:text-white
              "
            >

              <option value="all">
                Bütün məhsullar
              </option>

              <option value="inStock">
                Stokda olanlar
              </option>

              <option value="outOfStock">
                Stokda olmayanlar
              </option>

            </select>

          </div>

        </div>

      </div>

      {/* =========================================================
          PRODUCTS
      ========================================================== */}

      <main className="mx-auto max-w-[1600px] px-4 pb-12 pt-7 sm:px-6 lg:px-8">

        {filteredProducts.length > 0 && (

          <div
            className="
              grid
              grid-cols-2
              gap-3
              sm:grid-cols-3
              sm:gap-5
              lg:grid-cols-4
              xl:grid-cols-5
            "
          >

            {filteredProducts.map((product) => {

              const image =
                getProductImage(product);

              const isFavorite =
                isProductInFavorite(
                  product?._id
                );

              const isAddingFavorite =
                addingFavoriteId ===
                product?._id;

              return (

                <article
                  key={product._id}
                  className="
                    group
                    relative
                    flex
                    min-w-0
                    flex-col
                    overflow-hidden
                    rounded-[24px]
                    border
                    border-slate-200
                    bg-white
                    shadow-sm
                    transition-all
                    duration-300
                    hover:-translate-y-1
                    hover:border-indigo-200
                    hover:shadow-xl
                    hover:shadow-indigo-500/10
                    dark:border-slate-800
                    dark:bg-slate-900
                    dark:hover:border-indigo-500/30
                  "
                >

                  {/* =================================================
                      IMAGE
                  ================================================== */}

                  <div
                    className="
                      relative
                      aspect-square
                      w-full
                      overflow-hidden
                      bg-slate-100
                      dark:bg-slate-950
                    "
                  >

                    {image ? (
                      <img
                        src={image}
                        alt={
                          product.title ||
                          "Məhsul şəkli"
                        }
                        className="
                          h-full
                          w-full
                          cursor-pointer
                          object-cover
                          transition-transform
                          duration-500
                          group-hover:scale-105
                        "
                        onClick={() =>
                          navigate(
                            `/pagination/${product._id}`
                          )
                        }
                        onError={(e) => {
                          e.currentTarget.style.display =
                            "none";

                          if (
                            e.currentTarget
                              .nextSibling
                          ) {
                            e.currentTarget.nextSibling.style.display =
                              "flex";
                          }
                        }}
                      />
                    ) : null}

                    {/* FALLBACK IMAGE */}

                    <div
                      className={`absolute inset-0 items-center justify-center ${
                        image ? "hidden" : "flex"
                      }`}
                    >

                      <div className="text-center">

                        <PackageOpen className="mx-auto h-9 w-9 text-slate-300 dark:text-slate-700" />

                        <p className="mt-2 text-[11px] font-semibold text-slate-400">
                          Şəkil yoxdur
                        </p>

                      </div>

                    </div>

                    {/* DISCOUNT */}

                    {product.discountApplied && (
                      <div className="absolute left-3 top-3 rounded-lg bg-red-500 px-2.5 py-1 text-[10px] font-black text-white shadow-lg">
                        ENDİRİM
                      </div>
                    )}

                    {/* STOCK */}

                    {Number(product.stock) ===
                      0 && (
                      <div className="absolute bottom-3 left-3 rounded-lg bg-slate-900/85 px-2.5 py-1.5 text-[10px] font-bold text-white backdrop-blur-md">
                        Stokda yoxdur
                      </div>
                    )}

                    {/* =================================================
                        FAVORITE
                    ================================================== */}

                    <button
                      type="button"
                      aria-label={
                        isFavorite
                          ? "Məhsulu sevimlilərdən sil"
                          : "Məhsulu sevimlilərə əlavə et"
                      }
                      onClick={() =>
                        handleAddToFavorite(product)
                      }
                      disabled={
                        isAddingFavorite
                      }
                      className="
                        absolute
                        right-3
                        top-3
                        flex
                        h-10
                        w-10
                        items-center
                        justify-center
                        rounded-full
                        bg-white/95
                        text-rose-500
                        shadow-lg
                        backdrop-blur
                        transition
                        hover:scale-110
                        hover:bg-rose-500
                        hover:text-white
                        disabled:cursor-not-allowed
                        disabled:opacity-60
                        dark:bg-slate-900/95
                      "
                    >

                      {isAddingFavorite ? (
                        <Loader2 className="h-4 w-4 animate-spin" />
                      ) : (
                        <Heart
                          className="h-4 w-4"
                          fill={
                            isFavorite
                              ? "currentColor"
                              : "none"
                          }
                        />
                      )}

                    </button>

                  </div>

                  {/* =================================================
                      CONTENT
                  ================================================== */}

                  <div className="flex flex-1 flex-col p-3.5 sm:p-4">

                    {/* CATEGORY */}

                    {product.category && (
                      <div className="mb-2">

                        <span className="inline-flex max-w-full truncate rounded-lg bg-indigo-50 px-2.5 py-1 text-[10px] font-bold text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400">
                          {product.category}
                        </span>

                      </div>
                    )}

                    {/* TITLE */}

                    <button
                      type="button"
                      onClick={() =>
                        navigate(
                          `/pagination/${product._id}`
                        )
                      }
                      className="text-left"
                    >

                      <h3
                        className="
                          line-clamp-2
                          min-h-[40px]
                          text-sm
                          font-extrabold
                          leading-5
                          tracking-tight
                          text-slate-900
                          transition
                          group-hover:text-indigo-600
                          dark:text-white
                          dark:group-hover:text-indigo-400
                          sm:text-[15px]
                        "
                      >
                        {product.title ||
                          "Adsız məhsul"}
                      </h3>

                    </button>

                    {/* PRICE */}

                    <div className="mt-3">

                      {product.discountApplied ? (

                        <div className="flex flex-wrap items-center gap-2">

                          <span className="text-lg font-black text-indigo-600 dark:text-indigo-400 sm:text-xl">
                            {formatPrice(
                              product.price
                            )}{" "}
                            ₼
                          </span>

                          <span className="text-xs font-medium text-slate-400 line-through">
                            {formatPrice(
                              product.originalPrice
                            )}{" "}
                            ₼
                          </span>

                        </div>

                      ) : (

                        <span className="text-lg font-black text-slate-900 dark:text-white sm:text-xl">
                          {formatPrice(
                            product.price
                          )}{" "}
                          ₼
                        </span>

                      )}

                    </div>

                    {/* STOCK INFO */}

                    <div className="mt-2 min-h-[18px]">

                      {Number(product.stock) >
                      0 ? (

                        <div className="flex items-center gap-1.5 text-[11px] font-semibold text-emerald-500">

                          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />

                          Stokda {product.stock} ədəd

                        </div>

                      ) : (

                        <div className="text-[11px] font-semibold text-slate-400">
                          Hazırda mövcud deyil
                        </div>

                      )}

                    </div>

                    {/* ACTION */}

                    <button
                      type="button"
                      onClick={() =>
                        navigate(
                          `/pagination/${product._id}`
                        )
                      }
                      className="
                        mt-4
                        flex
                        h-11
                        w-full
                        items-center
                        justify-center
                        gap-2
                        rounded-xl
                        bg-slate-100
                        px-3
                        text-xs
                        font-extrabold
                        text-slate-700
                        transition-all
                        hover:bg-indigo-600
                        hover:text-white
                        dark:bg-slate-800
                        dark:text-slate-200
                        dark:hover:bg-indigo-600
                        sm:text-sm
                      "
                    >

                      Ətraflı bax

                      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />

                    </button>

                  </div>

                </article>

              );
            })}

          </div>

        )}

        {/* =========================================================
            EMPTY
        ========================================================== */}

        {!isProductsLoading &&
          filteredProducts.length === 0 && (

            <div className="flex justify-center py-16">

              <div className="w-full max-w-lg rounded-[28px] border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-10">

                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800">

                  <PackageOpen className="h-8 w-8 text-slate-400" />

                </div>

                <h2 className="mt-5 text-xl font-black">
                  Məhsul tapılmadı
                </h2>

                <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
                  Seçdiyiniz axtarış və filtr şərtlərinə uyğun
                  məhsul yoxdur.
                </p>

                {activeFilterCount > 0 && (

                  <button
                    type="button"
                    onClick={resetFilters}
                    className="
                      mt-6
                      rounded-xl
                      bg-slate-900
                      px-5
                      py-3
                      text-sm
                      font-bold
                      text-white
                      transition
                      hover:bg-indigo-600
                      dark:bg-white
                      dark:text-slate-900
                    "
                  >
                    Filtrləri sıfırla
                  </button>

                )}

              </div>

            </div>

          )}

        {/* =========================================================
            LOAD MORE
        ========================================================== */}

        {filteredProducts.length > 0 &&
          hasMore && (

            <div className="flex justify-center pt-10">

              <button
                type="button"
                onClick={loadMore}
                disabled={isLoadingMore}
                className="
                  inline-flex
                  min-w-[220px]
                  items-center
                  justify-center
                  gap-2
                  rounded-2xl
                  bg-white
                  px-7
                  py-3.5
                  text-sm
                  font-extrabold
                  text-slate-700
                  shadow-sm
                  ring-1
                  ring-slate-200
                  transition-all
                  hover:-translate-y-0.5
                  hover:bg-indigo-600
                  hover:text-white
                  hover:ring-indigo-600
                  disabled:cursor-not-allowed
                  disabled:opacity-60
                  dark:bg-slate-900
                  dark:text-slate-200
                  dark:ring-slate-800
                "
              >

                {isLoadingMore ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" />
                    Yüklənir...
                  </>
                ) : (
                  <>
                    Daha çox göstər
                    <ArrowRight className="h-4 w-4 rotate-90" />
                  </>
                )}

              </button>

            </div>

          )}

        {/* =========================================================
            ALL PRODUCTS LOADED
        ========================================================== */}

        {!hasMore &&
          products.length > 0 && (

            <div className="pt-10">

              <div className="mx-auto flex max-w-xl items-center justify-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4 dark:border-emerald-500/20 dark:bg-emerald-500/5">

                <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-500" />

                <p className="text-sm font-bold text-emerald-700 dark:text-emerald-300">
                  Bütün məhsullar göstərildi.
                </p>

              </div>

            </div>

          )}

      </main>

    </div>
  );
};

export default Paginationdiz;